/**
 * Aceleasi formate ca in portal (public/js/general.js: Convert.FormatSecondsAsYearsString,
 * formatFileSize; moment.fromNow / moment.format), ca cifrele din liste sa
 * arate la fel. Scrise aici o singura data, fara moment.js (300 KB).
 */

export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/** Convert.FormatSecondsAsYearsString: "2years 3months " sau "0h". */
export function secondsAsYears(seconds: number): string {
  let s = ''
  const years = Math.floor(seconds / 31556926)
  if (years >= 1) {
    s += years.toString() + 'year' + (years === 1 ? ' ' : 's ')
    seconds -= years * 31556926
  }
  const months = Math.floor(seconds / 2629743.83)
  if (months >= 1) {
    s += months.toString() + 'month' + (months === 1 ? ' ' : 's ')
    seconds -= months * 2629743.83
  }
  if (s === '') s += '0h'
  return s
}

/** formatFileSize: 17179869184 -> "16 GB". */
export function fileSize(size: number): string {
  const sizes = [' Bytes', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB']
  for (let i = 1; i < sizes.length; i++) {
    if (size < Math.pow(1024, i)) {
      return Math.round((size / Math.pow(1024, i - 1)) * 100) / 100 + sizes[i - 1]
    }
  }
  return String(size)
}

/** moment(value) pentru "YYYY-MM-DD HH:mm:ss" (ora locala) - null cand nu e data. */
export function stamp(value: unknown): Date | null {
  if (!value) return null
  const when = new Date(String(value).replace(' ', 'T'))
  return isNaN(when.getTime()) ? null : when
}

/** Secunde Unix, ca moment().format('X'). */
export function unix(when: Date): number {
  return Math.floor(when.getTime() / 1000)
}

/** moment(when).fromNow(), cu pragurile lui moment 2.x. */
export function fromNow(when: Date, now: Date = new Date()): string {
  const diff = now.getTime() - when.getTime()
  const future = diff < 0
  const seconds = Math.round(Math.abs(diff) / 1000)
  const minutes = Math.round(seconds / 60)
  const hours = Math.round(minutes / 60)
  const days = Math.round(hours / 24)
  const months = Math.round(days / 30.4)
  const years = Math.round(days / 365)

  let text: string
  if (seconds < 45) text = 'a few seconds'
  else if (seconds < 90) text = 'a minute'
  else if (minutes < 45) text = `${minutes} minutes`
  else if (minutes < 90) text = 'an hour'
  else if (hours < 22) text = `${hours} hours`
  else if (hours < 36) text = 'a day'
  else if (days < 26) text = `${days} days`
  else if (days < 46) text = 'a month'
  else if (days < 320) text = `${months} months`
  else if (days < 548) text = 'a year'
  else text = `${years} years`

  return future ? `in ${text}` : `${text} ago`
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function ordinal(n: number): string {
  const b = n % 100
  if (b >= 11 && b <= 13) return `${n}th`
  switch (n % 10) {
    case 1:
      return `${n}st`
    case 2:
      return `${n}nd`
    case 3:
      return `${n}rd`
    default:
      return `${n}th`
  }
}

const two = (n: number) => String(n).padStart(2, '0')

/** moment(when).format('MMM Do YYYY, HH:mm:ss'). */
export function exact(when: Date): string {
  return `${MONTHS[when.getMonth()]} ${ordinal(when.getDate())} ${when.getFullYear()}, ${two(when.getHours())}:${two(when.getMinutes())}:${two(when.getSeconds())}`
}

/** moment(when).format('D MMM YYYY') - ApplicationLicensesModel, start_date. */
export function dayMonthYear(when: Date): string {
  return `${when.getDate()} ${MONTHS[when.getMonth()]} ${when.getFullYear()}`
}

/** moment(end).from(start, true) - durata fara "ago" / "in". */
export function fromDuration(end: Date, start: Date): string {
  const text = fromNow(end, start)
  if (text.startsWith('in ')) return text.slice(3)
  if (text.endsWith(' ago')) return text.slice(0, -4)
  return text
}
